import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
// REDUX
import { ADD_USER } from "redux/types";
import { useDispatch, useSelector } from "react-redux";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function SignIn() {
    const rState = useSelector((s) => s.user.userData);
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userData = useSelector((state) => state.user.userData);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // if (!!rState.role || rState.role === "super-admin") return navigate(-1);
    }, []);

    const onSignIn = async () => {
        if (!email || !password) {
            return enqueueSnackbar("Please Fill All The Details !!!", {
                variant: "error",
            });
        }

        try {
            setLoading(true);
            const res = await axios.post(
                `${process.env.REACT_APP_BASEURL}/admin/users/sign-in`,
                {
                    email,
                    password,
                }
            );

            if (res.data.success) {
                const userData = { ...res.data.data, auth: res.data.auth };

                dispatch({ type: ADD_USER, payload: userData });

                // Save the user ID and role to local storage
                localStorage.setItem("user_id", userData.user_id);
                localStorage.setItem("role", userData.role);
                localStorage.setItem("authToken", userData.auth);
                localStorage.setItem("name", userData.name);
                localStorage.setItem("email", userData.email);
                // Set the loggedIn key to true to indicate user is logged in
                localStorage.setItem("loggedIn", "true");

                // Role-based redirection
                if (userData.role === "superadmin") {
                    enqueueSnackbar("Super Admin Login Successful", {
                        variant: "success",
                    });
                    navigate("/dashboard");
                } else if (userData.role === "admin") {
                    enqueueSnackbar("Admin Login Successful", {
                        variant: "success",
                    });
                    navigate("/dashboard");
                } else {
                    enqueueSnackbar("Sub Admin Login Successful", {
                        variant: "success",
                    });
                    navigate("/devices");
                }
            } else {
                enqueueSnackbar(res.data.message, { variant: "error" });
            }
        } catch (error) {
            console.log(error);
            enqueueSnackbar(
                "Error occurred while signing in. Please try again.",
                { variant: "error" }
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    textAlign="center"
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white">
                        Sign in
                    </MDTypography>
                </MDBox>

                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                        <MDBox mb={2}>
                            <MDInput
                                type="email"
                                label="Email"
                                fullWidth
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <MDInput
                                type="password"
                                label="Password"
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton
                                variant="gradient"
                                color="info"
                                fullWidth
                                onClick={onSignIn}
                            >
                                {loading ? (
                                    <CircularProgress
                                        size={20}
                                        sx={{ color: "inherit" }}
                                    />
                                ) : (
                                    "sign in"
                                )}
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

export default SignIn;
